module.exports = __webpack_public_path__ + "img/favicon.9d6f091.png";